import {useEffect, useState} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {UserModel} from '../../modules/auth'
import {TableColumn} from 'react-data-table-component/dist/DataTable/types'
import DataTable from 'react-data-table-component'
import {getClaimsList, getUserList, listUnitTree} from '../../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {customStyles} from '../../../dataTableStyle'
import AddUserModal from './Modals/UserManagementModals/AddUserModal'
import UserDeletionModal from './Modals/UserManagementModals/UserDeletionModal'
import UserEditModal from './Modals/UserManagementModals/UserEditModal'
import UserUnitModal from './Modals/UserManagementModals/UserUnitModal'
import UserClaimModal from './Modals/UserManagementModals/UserClaimModal'
import {KTIcon} from '../../../_metronic/helpers'
import {useLocation, useNavigate} from 'react-router-dom'

// Tablo Veri Tipleri
type User = {
  id: number
  firstName: string
  lastName: string
  email: string
  isActivated: boolean
}

function UserManagement() {
  const intl = useIntl()
  const {state}: any = useLocation()
  const navigate = useNavigate()

  const [userList, setUserList] = useState<Array<UserModel>>(state?.data || [])
  const [action, setAction] = useState(false)

  const [searchTerm, setSearchTerm] = useState<string>('')

  const [roles, setRole] = useState<[]>([])
  const [units, setUnits] = useState<[]>([])

  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [claimId, setClaimId] = useState<number>(0)
  const [unitId, setUnitId] = useState<number>(0)
  const [email, setEmail] = useState<string>('')
  const [IsActivated, setIsActivated] = useState<boolean>(true)
  const [IsActivate, setIsActivate] = useState<boolean>(true)

  const [listing, setListing] = useState<boolean>(false)
  const [page, setPage] = useState(state?.page ?? 1)
  const [rowsPerPage, setRowsPerPage] = useState(state?.rowsPerPage ?? 5)

  const getList = async () => {
    try {
      const {data} = await getUserList(
        firstName,
        lastName,
        claimId,
        unitId,
        email,
        IsActivated,
        IsActivate
      )
      setUserList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
      setUserList([])
    }
  }

  // Role Listesi
  const getListClaims = async () => {
    try {
      const {data} = await getClaimsList()
      setRole(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  // Birim  Listesi
  const getListUnits = async () => {
    try {
      const {data} = await listUnitTree(0, 0)
      setUnits(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  useEffect(() => {
    getListClaims()
    getListUnits()
  }, [])

  useEffect(() => {
    if (action) {
      getList()
      setAction(false)
    }
  }, [action])

  useEffect(() => {
    if (listing) {
      getList()
      setListing(false)
    }
  }, [listing])

  // Search İşlemleri
  const keys = ['firstName', 'lastName', 'email']

  const search = (list: any) => {
    if (searchTerm) {
      return list.filter((item: any) =>
        keys.some((key) => item[key].toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))
      )
    } else {
      return userList
    }
  }

  // Data Table Veri
  /*const columns: TableColumn<User>[] = [
    {
      name: 'Id',
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: 'First Name',
      selector: (row) => row.firstName,
      sortable: true,
    },
    {
      name: 'Last Name',
      selector: (row) => row.lastName,
      sortable: true,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: 'Active',
      cell: (row) =>
        row.isActivated ? (
          <span className='badge badge-light-success  fs-6'>True</span>
        ) : (
          <span className='badge badge-light-danger  fs-6'>False</span>
        ),
    },
    {
      name: 'Actions',
      center: true,
      cell: (row: any) => (
        <div>
          <a
            type='button'
            className='btn btn-icon btn-light-primary'
            data-bs-toggle='modal'
            data-bs-target='#claimUserModal'
            onClick={() => setUserID(row.id)}
          >
            <i className='las la-user-shield fs-1' />
          </a>{' '}
          <a
            type='button'
            className='btn btn-icon btn-light-warning'
            data-bs-toggle='modal'
            data-bs-target='#unitUserModal'
            onClick={() => setUserID(row.id)}
          >
            <i className='las la-building fs-1' />
          </a>{' '}
          <a
            type='button'
            className='btn btn-icon btn-light-success'
            data-bs-toggle='modal'
            data-bs-target='#updateUserModal'
            onClick={() => setSelectUser(row)}
          >
            <i className='las la-edit fs-1' />
          </a>{' '}
          <a
            type='button'
            data-bs-toggle='modal'
            data-bs-target='#deleteUserModal'
            className='btn btn-icon btn-light-danger'
            onClick={() => setDeleteUserID(row.id)}
          >
            <i className='las la-trash fs-1' />
          </a>
        </div>
      ),
    },
  ]*/

  const columns: TableColumn<User>[] = [
    {
      name: 'First Name',
      selector: (row) => row.firstName,
      sortable: true,
    },
    {
      name: 'Last Name',
      selector: (row) => row.lastName,
      sortable: true,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: 'Active',
      cell: (row) =>
        row.isActivated ? (
          <span className='badge badge-light-success  fs-6'>True</span>
        ) : (
          <span className='badge badge-light-danger  fs-6'>False</span>
        ),
    },
    {
      name: 'Actions',
      cell: (row: any) => (
        <div>
          <a
            type='button'
            className='btn btn-icon btn-light-warning'
            data-bs-toggle='modal'
            onClick={() =>
              navigate('/management/users/selected-user', {
                state: {row, page, rowsPerPage, userList},
              })
            }
          >
            <i className='las la-edit fs-1' />
          </a>
        </div>
      ),
    },
  ]

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.ADMIN_PANEL'})}</PageTitle>
      {/* 👇 List User Card 👇 */}
      <div className='card card-custom gx-xl-8 mt-lg-n16 mt-2'>
        <div className='col-xxl-12'>
          <div className='card card-flush p-5 mb-5'>
            <div className='mb-10 row'>
              {/* 👇 First Name 👇 */}
              <div className='col'>
                <label className='form-label fw-bold'>
                  {intl.formatMessage({id: 'USER.FIRSTNAME'})}
                </label>
                <input
                  type='text'
                  className='form-control '
                  placeholder={intl.formatMessage({id: 'USER.FIRSTNAME'})}
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      setListing(true)
                    }
                  }}
                />
              </div>
              {/* 👆 First Name  👆 */}
              {/* 👇 Last Name   👇 */}
              <div className='col'>
                <label className='form-label fw-bold'>
                  {intl.formatMessage({id: 'USER.LASTNAME'})}
                </label>
                <input
                  type='text'
                  className='form-control '
                  placeholder={intl.formatMessage({id: 'USER.LASTNAME'})}
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      setListing(true)
                    }
                  }}
                />
              </div>
              {/* 👆 Last Name  👆 */}
            </div>

            <div className='mb-10 row'>
              {/* 👇 Role 👇 */}
              <div className='col'>
                <label className='form-label fw-bold'>
                  {intl.formatMessage({id: 'USER.ROLE'})}
                </label>

                <select
                  className='form-select form-select-solid'
                  data-kt-select2='true'
                  data-placeholder='Select option'
                  data-allow-clear='true'
                  value={claimId}
                  onChange={(e) => setClaimId(Number(e.target.value))}
                >
                  <option value={0}>{intl.formatMessage({id: 'USER.ALLROLE'})}</option>
                  {roles.map((item: any, index: number) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* 👆 Role 👆 */}
              {/* 👇 Unit  👇 */}
              <div className='col'>
                <label className='form-label fw-bold'>
                  {intl.formatMessage({id: 'USER.UNIT'})}
                </label>
                <select
                  className='form-select form-select-solid'
                  data-kt-select2='true'
                  data-placeholder='Select option'
                  data-allow-clear='true'
                  value={unitId}
                  onChange={(e) => setUnitId(Number(e.target.value))}
                >
                  <option value={0}>{intl.formatMessage({id: 'USER.ALLUNIT'})}</option>
                  {units.map((item: any, index: number) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* 👆 Unit 👆 */}
            </div>

            <div className='mb-10 row'>
              {/* 👇 Email 👇 */}
              <div className='col'>
                <label className='form-label fw-bold'>
                  {intl.formatMessage({id: 'USER.EMAIL'})}
                </label>
                <input
                  type='email'
                  className='form-control '
                  placeholder={intl.formatMessage({id: 'USER.EMAIL'})}
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      setListing(true)
                    }
                  }}
                />
              </div>
              {/* 👆 Email  👆 */}
              {/* 👇 CheckBoxs 👇 */}
              <div className='col d-flex flex-column justify-content-center'>
                <label className='form-label fw-bold'>{/* */}</label>
                <div className='row mt-3'>
                  <div className='col-auto mt-2'>
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        id='IsActivated'
                        type='checkbox'
                        checked={IsActivated}
                        onChange={(e) => setIsActivated(e.target.checked)}
                      />
                      <label className='form-check-label' htmlFor='IsActivated'>
                        {intl.formatMessage({id: 'USER.ISACTIVATED'})}
                      </label>
                    </div>
                  </div>
                  <div className='col-auto mt-2'>
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        id='IsActive'
                        type='checkbox'
                        checked={IsActivate}
                        onChange={(e) => setIsActivate(e.target.checked)}
                      />
                      <label className='form-check-label' htmlFor='IsActive'>
                        {intl.formatMessage({id: 'USER.ISACTIVE'})}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {/* 👆 CheckBoxs 👆 */}
            </div>

            {/* 👇 Listing Button  👇 */}
            <div className='d-flex justify-content-end'>
              <button type='button' className='btn btn-primary' onClick={() => setListing(true)}>
                {intl.formatMessage({id: 'USER.LIST'})}
              </button>

              <a
                className='btn btn-light-primary ms-2'
                data-bs-toggle='modal'
                data-bs-target='#addUserModal'
              >
                <KTIcon iconName='plus' className='fs-3' />
                {intl.formatMessage({id: 'USER.ADDUSER'})}
              </a>
            </div>
            {/* 👆 Listing Button   👆 */}
          </div>
        </div>
      </div>
      {/* 👆 List User Card   👆 */}

      <div className='card card-custom mt-4 '>
        {/*}
        <div className='card-header pt-6'>
          <div className='d-flex align-items-center position-relative my-1'>
            <KTSVG
              path='/media/icons/duotune/general/gen021.svg'
              className='svg-icon-1 position-absolute ms-6'
            />
            <input
              type='text'
              data-kt-user-table-filter='search'
              className='form-control form-control-solid w-sm-450px ps-14'
              placeholder='Search user'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className='card-toolbar'>
            <a
              className='btn btn-light-primary'
              data-bs-toggle='modal'
              data-bs-target='#addUserModal'
            >
              <KTIcon iconName='plus' className='fs-3' />
              Add User
            </a>
          </div>
             
        </div>
   {*/}
        <div className='card-body table-responsive'>
          <DataTable
            columns={columns}
            data={search(userList)}
            pagination
            paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
            customStyles={customStyles}
            className='table table-striped'
            striped
            paginationDefaultPage={page}
            onChangePage={(e) => setPage(e)}
            paginationPerPage={rowsPerPage}
            onChangeRowsPerPage={(e) => setRowsPerPage(e)}
          />
          {/* Kullanıcı Ekleme Modalı */}
          <AddUserModal setAction={setAction} page={page} row={rowsPerPage} />
          {/* Kullanıcı Düzenleme Modalı }
          <UserEditModal setAction={setAction} initialValues={initialValues} />
          {/* Kullanıcı Silme Modalı }
          <UserDeletionModal setAction={setAction} deleteUserID={deleteUserID} />
          {/* User Claim Modal }
          <UserClaimModal userId={userID} />
          {/* User Unit Modal }
          <UserUnitModal userId={userID} />
          {*/}
        </div>
      </div>
    </>
  )
}

export default UserManagement
